import styled, { css } from 'styled-components';
import { Link } from 'react-router';
import { color, height, media, zIndex } from '../../styles_js/variables';

const menuItemSt = `
  display: inline-block;
  background-color: transparent;
  font-size: 14px;
`;

const activeBorder = css`
  border-bottom: 4px solid ${color.brandPrimary};
`;

const border = css`
  border-bottom: 4px solid ${color.grayLightest};
`;

export const MenuBarSt = styled.div`
  z-index: ${zIndex.navbar};
  display: flex;
  background-color: ${color.grayLightest};
  position: fixed;
  top: ${height.topNavBar}px;
  right: 0;
  left: 0;
`;

export const MenuItemButtonSt = styled.button.attrs(() => ({ type: 'button' }))`
  border: 0;
  ${props => (props.isactive ? activeBorder : border)};
  cursor: ${props => !props.isactive && 'pointer'};
  font-weight: ${props => props.isactive && 400};
  pointer-events: ${props => props.isactive && 'none'};
  padding-right: 0;
  padding-left: 0;

  ${menuItemSt};
  ${media.md(css`
    font-size: 16px;
  `)};

  &:not(:last-child) {
    margin-right: 20px;

    ${media.md(css`
      margin-right: 48px;
    `)};
  }

  span {
    display: flex;
    align-items: center;
    height: ${height.topNavBar - 4}px;
    color: ${color.brandSecondary};
  }
`;

export const MenuItemLinkSt = styled(Link)`
  border: 0;
  ${props => (props.isactive ? activeBorder : border)};
  cursor: ${props => !props.isactive && 'pointer'};
  font-weight: ${props => props.isactive && 400};
  pointer-events: ${props => props.isactive && 'none'};
  padding-right: 0;
  padding-left: 0;

  ${menuItemSt};
  ${media.md(css`
    font-size: 16px;
  `)};

  &:not(:last-child) {
    margin-right: 20px;

    ${media.md(css`
      margin-right: 48px;
    `)};
  }

  span {
    display: flex;
    align-items: center;
    height: ${height.topNavBar - 4}px;
    color: ${color.brandSecondary};
  }
`;
